import FloatContainer from '../../ui-kit/components/wrappers/FloatContainer'
import NotificationButton from '../../ui-kit/components/atoms/buttons/NotificationButton'
import NotificationPanel from './NotificationPanel'

const Notifications = () => {
  return (
    <div className="notifications">
      <FloatContainer>
        <NotificationButton />
        <NotificationPanel />
      </FloatContainer>
    </div>
  )
}

export default Notifications
